import { fetchSupabaseFunction } from "@/lib/shopifySessionToken";

interface AccountContextResponse {
  status?: "connected" | "mismatch" | "unconnected";
  merchantId?: string;
  storeName?: string | null;
  maskedEmail?: string | null;
  error?: string;
}

async function callAccountSwitchFunction<T extends AccountContextResponse>(
  functionName: string,
  body: Record<string, unknown>,
): Promise<T> {
  const response = await fetchSupabaseFunction(functionName, { body });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(typeof payload?.error === "string" ? payload.error : "Unable to validate the connected Shopify account");
  }
  return payload as T;
}

export function checkShopifyAccountContext(shopDomain: string) {
  return callAccountSwitchFunction<AccountContextResponse>("check-shopify-account-context", { shopDomain });
}

export function requestShopifyAccountSwitchOtp(shopDomain: string) {
  return callAccountSwitchFunction<AccountContextResponse>("request-shopify-account-switch-otp", { shopDomain });
}

export function verifyShopifyAccountSwitchOtp(
  shopDomain: string,
  code: string,
  redirectTo: string,
) {
  return callAccountSwitchFunction<{ success?: boolean; actionLink?: string; error?: string }>(
    "verify-shopify-account-switch-otp",
    { shopDomain, code, redirectTo },
  );
}
